import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Flex, Text, Link
} from 'components/ui';
import Button from 'components/Button';
import {
    colors, fontSizes, space, radii, buttons
} from 'style/config';
import basketConstants from 'constants/Basket';

function ConfirmationMessage({ confirmation, onDismiss, onUndo, getText }) {
    if (!confirmation) {
        return null;
    }

    const { brandName, productName, basketType } = confirmation;
    const { BasketType } = basketConstants;

    // Map basketType to deliveryMethod key for localization
    let deliveryMethodKey = 'deliveryMethodStandard';

    if (basketType === BasketType.BOPIS) {
        deliveryMethodKey = 'deliveryMethodBOPIS';
    } else if (basketType === BasketType.SameDay) {
        deliveryMethodKey = 'deliveryMethodSameday';
    }

    const deliveryMethodText = getText(deliveryMethodKey);

    return (
        <Box css={styles.container}>
            <Text css={styles.messageText}>
                <Text
                    as='span'
                    fontWeight='bold'
                    dangerouslySetInnerHTML={{
                        __html: `${brandName} ${productName}`
                    }}
                />{' '}
                {getText('movedToBasket', [deliveryMethodText])}
            </Text>
            <Flex
                gap={3}
                marginTop={2}
                alignItems='center'
            >
                <Button
                    variant='secondary'
                    size='sm'
                    onClick={onDismiss}
                    css={styles.button}
                >
                    {getText('gotIt')}
                </Button>
                <Link
                    css={styles.undoLink}
                    onClick={onUndo}
                >
                    {getText('undo')}
                </Link>
            </Flex>
        </Box>
    );
}

const styles = {
    container: {
        backgroundColor: colors.nearWhite,
        borderRadius: `${radii[2]}px`,
        padding: `${space[3]}px`,
        marginBottom: `${space[3]}px`
    },
    messageText: {
        fontSize: `${fontSizes.sm}px`,
        lineHeight: '14px'
    },
    button: {
        height: `${buttons.HEIGHT_XS}px`,
        minHeight: `${buttons.HEIGHT_XS}px`,
        fontSize: `${fontSizes.sm}px`,
        padding: '5px 10px',
        borderRadius: `${space[4]}px`,
        borderWidth: '1px'
    },
    undoLink: {
        color: colors.blue,
        fontSize: `${fontSizes.sm}px`,
        lineHeight: '14px',
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }
};

ConfirmationMessage.propTypes = {
    confirmation: PropTypes.shape({
        skuId: PropTypes.string,
        productId: PropTypes.string,
        brandName: PropTypes.string,
        productName: PropTypes.string,
        deliveryOption: PropTypes.string,
        basketType: PropTypes.string,
        qty: PropTypes.number,
        sku: PropTypes.object
    }),
    onDismiss: PropTypes.func.isRequired,
    onUndo: PropTypes.func.isRequired,
    getText: PropTypes.func.isRequired
};

export default wrapFunctionalComponent(ConfirmationMessage, 'ConfirmationMessage');
